<template>
	<no-auth>
		<div class="friend-welcome-message">
			<el-card style="margin-bottom: 20px;">
				<p style="font-size: 14px;color: #606266;margin: 0;line-height: 22px;">
					你可以在该页面，管理进群欢迎语素材或者获取你在企业微信后台添加的进群欢迎语素材。添加成功的进群欢迎语，企微客户群的群主可在群聊中选择其中一条欢迎语内容使用。<br />

					根据企业微信规定，1个企业<span style="color: #F56C6C;">最多可添加100条</span>群欢迎语素材，包括在企业微信后台配置的群欢迎语。<br />

					因企业微信接口限制，<span style="color: #F56C6C;">在企业微信后台管理的欢迎语不会同步至企店后台</span>，请直接在企店后台管理群欢迎语。</p>
			</el-card>
			<el-card>
				<div class="search">
					<div style="padding-right: 150px;position: relative;">
						<span style="font-weight: bold;padding-right: 4px;color: #606266;font-size: 14px;">关键字:</span>
						<el-input v-model="keywords" placeholder="欢迎语内容"
							style="width: 200px;margin-right: 10px;margin-bottom: 10px;"></el-input>

						<el-button type="primary" style="margin-right: 10px;margin-bottom: 10px;"
							@click="pageIndex=1;getList()">查询</el-button>
						<buttonPermissions :datas="'joinGroupWelcomeAdd'">
							<el-button type="primary" style="margin-right: 10px;margin-bottom: 10px;"
								@click="handleEdit({})">
								添加欢迎语
							</el-button>
						</buttonPermissions>

						<div style="position: absolute;right: 20px;top: 0px;">
							<experience-code docUrl="https://jusnn6k8al.feishu.cn/docs/doccn1OlUrveTEY15g4FskuVA5b"></experience-code>
						</div>
					</div>

					<el-table :data="list" ref="multipleTable" style="width: 100%" v-loading="tableLoading">
						<el-table-column prop="Welcome" label="欢迎语">
							<template slot-scope="scope">
								<div class="welcome-view">
									<div class="welcome-text">{{scope.row.Welcome}}</div>
									<div class="welcome-tag">{{scope.row.AttachmentTypeValue}}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="Referer" label="来源">
						</el-table-column>
						<el-table-column prop="AddTime" label="创建时间">
						</el-table-column>
						<el-table-column prop="control" label="操作" width="140">
							<template slot-scope="scope">
								<buttonPermissions :datas="'joinGroupWelcomeEdit'">
									<el-button type="text" @click="handleEdit(scope.row)"
										style="margin-right: 10px;">编辑</el-button>
								</buttonPermissions>
								<buttonPermissions :datas="'joinGroupWelcomeDelete'">
									<el-button type="text" style="color: #F56C6C;" @click="handleDelete(scope.row)">删除
									</el-button>
								</buttonPermissions>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<div class="left" style="margin-left: 15px;">
						</div>
						<el-pagination :page-size="pageSize" :total="total" :current-page="pageIndex"
							:page-sizes="[5, 10, 15, 20, 30, 40]" @size-change="sizeChange"
							@current-change="currentChange" layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</div>


				</div>
			</el-card>
		</div>
	</no-auth>
</template>

<script>
	import {
		qyWeixinJoinGroupWelcomelist,
		qyWeixinJoinGroupWelcomedelete,
		qyWeixinJoinGroupWelcomeinfo
	} from '@/api/sv1.0.0.js';

	import noAuth from './noAuth.vue';
	import buttonPermissions from '@/components/buttonPermissions';
	import experienceCode from '@/components/experienceCode';

	import config from '@/config/index'

	export default {
		components: {
			noAuth,
			buttonPermissions,
			experienceCode
		},
		data() {
			return {
				imgApi: config.UPLOAD_IMG,

				keywords: '',
				tableLoading: false,
				pageIndex: 1,
				pageSize: 20,
				total: 0,
				list: [],
			}
		},
		created() {},
		beforeMount() {},
		mounted() {
			this.getList();
		},
		methods: {
			async getList() {
				this.tableLoading = true;
				try {
					const res = await qyWeixinJoinGroupWelcomelist({
						Skip: (this.pageIndex - 1) * this.pageSize,
						Take: this.pageSize,
						Keywords: this.keywords
					})

					if (res.IsSuccess) {
						this.list = res.Result.Results;
						this.total = res.Result.Total;
					}
				} catch (e) {} finally {
					this.tableLoading = false;
				}
			},
			sizeChange(value) {
				this.pageSize = value;
				this.getList();
			},
			currentChange(index) {
				this.pageIndex = index;
				this.getList()
			},
			handleEdit(record) {
				if (!record.Id){
					this.$router.push({
						name: 'joinGroupMessageEdit',
						query: {
							id: ''
						}
					})
				}else{
					this.checkInfo(record, res => {
						if (res.Result.QyWeixinJoinGroupWelcome && res.Result.QyWeixinJoinGroupWelcome.QyWeixinGroupFissionActivityId) {
							this.$router.push({
								path: '/Customer/groupfission/groupfissionEdit',
								query: {
									Id: res.Result.QyWeixinJoinGroupWelcome.QyWeixinGroupFissionActivityId,
									isedit:true,
								}
							})
						} else {
							this.$router.push({
								name: 'joinGroupMessageEdit',
								query: {
									id: record.Id || ''
								}
							})
						}
					})
				}
				
			},
			handleDelete(record) {
			
				this.$confirm('删除后，会影响正在使用该欢迎语的客户群，需要员工重新选择客户群的欢迎语。是否确认继续删除？', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '关闭',
					type: 'warning'
				}).then(() => {
					
					this.checkInfo(record, res => {
						if (!res.Result.ActivityIsFinish && res.Result.QyWeixinJoinGroupWelcome && res.Result
							.QyWeixinJoinGroupWelcome.QyWeixinGroupFissionActivityId) {
							this.$confirm('欢迎语通过群裂变活动创建，活动未结束，暂不支持删除。', '提示', {
								confirmButtonText: '确认',
								cancelButtonText: '关闭',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						} else {
							this.sureDelete(record.Id)
						}
					});
					
					
				}).catch(() => {});
				
				


			},
			async checkInfo(record, callback) {
				const res = await qyWeixinJoinGroupWelcomeinfo({
					Id: record.Id
				})

				if (res.IsSuccess) {
					callback && callback(res);
				}
			},
			async sureDelete(id) {
				try {
					const res = await qyWeixinJoinGroupWelcomedelete({
						Id: id
					})

					this.$message.success('删除成功');

					this.getList();
				} catch (e) {
					//TODO handle the exception
				}
			}

		}
	}
</script>

<style lang="less" scoped>
	.friend-welcome-message {

		.search {
			position: relative;
			margin-bottom: 15px;

			.help {
				position: absolute;
				right: 0;
				top: 5px;
				white-space: nowrap;
				color: #666;
				cursor: pointer;
			}
		}

		.employee-list {
			margin-left: 10px;
			display: flex;
			align-items: center;
			flex-wrap: wrap;

			.employee-item {
				display: flex;
				align-items: center;
				height: 26px;
				margin-right: 10px;
				margin-bottom: 5px;
				margin-top: 5px;
				padding: 0 5px;
				font-size: 12px;
				border: 1px solid #ddd;
				border-radius: 3px;
				white-space: nowrap;

				.e-hd {
					width: 18px;
					height: 18px;
					overflow: hidden;
					border-radius: 2px;
					margin-right: 5px;
					background-color: #F6F6F6;
				}

				.e-no-hd {
					display: inline-block;
					width: 18px;
					height: 18px;
					line-height: 18px;
					text-align: center;
					font-size: 12px;
					color: #fff;
					border-radius: 2px;
					vertical-align: 1px;
					background-color: #409eff;
					margin-right: 5px;
				}

			}
		}

		.pagination {
			display: flex;
			margin-top: 15px;
			justify-content: space-between;
			align-items: center;
		}

		.welcome-view {
			display: inline-flex;
			max-width: 100%;
			overflow: auto;

			.welcome-text {
				flex: 1 1 auto;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.welcome-tag {
				flex: 0 0 auto;
			}
		}
	}
</style>
